// extracted by mini-css-extract-plugin
export default {"resultsWrapper":"style-module--resultsWrapper--bf760","noResults":"style-module--noResults--bc74b"};